<template>
  <van-popup :value="value" @input="onValueChange"
             style="background: #333333;border-radius: 10px;width:80%"
             :close-on-click-overlay="true">

    <div class="age-verify">
      <div class="title">年龄认证</div>
      <div class="input-birth">

        <div>激活烟弹前请先验证您的年龄:</div>


        <input type="date" class="date-input"
               v-model="birth"
               ref="birth"
               style="border:1px solid #ed6c0f;border-radius:4px;padding:8px; width:200px;"
               @change="onBirthChange"
               inputmode="numeric"
               :max="maxDate"
               required/>
      </div>

      <van-button style="margin-top:16px;border-radius: 10px;" type="primary" color="#ed6c0f"
                  @click="onVerify">{{
          $t('ProductInfo.activatedDevice')
        }}
      </van-button>
      <!--      <van-button style="margin-top:16px;border-radius: 10px;" type="primary" color="#ed6c0f"-->
      <!--                  @click="onVerify">Activate Device-->
      <!--      </van-button>-->
    </div>
  </van-popup>
</template>


<script>
export default {
  name: "PopupAgeVerify",
  props: {
    value: {
      type: Boolean,
    }
  },
  data() {
    return {
      birth: '2025-03-18',
      maxDate: new Date()
    }
  },
  methods: {
    onBirthChange(e) {
      console.log(e.target.value)
      const date = new Date()
      if (new Date(e.target.value) >= date) {
        const month = date.getMonth() + 1 > 9 ? `${date.getMonth() + 1}` : `0${date.getMonth() + 1}`
        this.birth = `${date.getFullYear()}-${month}-${date.getDate()}`
      }
    },
    onValueChange(e) {
      this.$emit('input', e)
    },
    onActivated() {
    },
    onVerify() {
      if (this.isOver21Years(new Date(this.birth))) {
        this.$emit('onActivated')
        return
      }
      this.$toast('You are not yet 21 years old, so you cannot use the activation function.')
    },
    isOver21Years(oldDate, newDate = new Date()) {
      const age = newDate.getFullYear() - oldDate.getFullYear();
      const monthDiff = newDate.getMonth() - oldDate.getMonth();
      const dayDiff = newDate.getDate() - oldDate.getDate();

      // 先比年份，再判断月日是否已经过了生日
      if (age > 21) return true;
      if (age < 21) return false;
      if (monthDiff > 0) return true;
      if (monthDiff < 0) return false;
      return dayDiff >= 0;
    }
  },
  created() {
    const date = new Date()
    const month = date.getMonth() + 1 > 9 ? `${date.getMonth() + 1}` : `0${date.getMonth() + 1}`
    this.birth = `${date.getFullYear()}-${month}-${date.getDate()}`
  }
}
</script>

<style scoped lang="less">
.age-verify {
  display: flex;
  flex-direction: column;
  padding: 20px;

  .title {
    color: white;
    font-size: 14px;
    font-weight: bold;
  }

  .input-birth {
    margin-top: 20px;
  }
}

.date-input {
  width: 100%;
  padding: 12px 18px;
  font-size: 16px;
  font-family: inherit;
  box-shadow: 0 0 0 1px #ed6c0f;
  border: none;
  border-radius: 12px;
  transition: all 0.3s;
  text-align: center;
  cursor: text;
  background: #333333;
  margin-top: 16px;
}

</style>